import React, {FC} from "react"
import {MarkdownAtom, MarkdownBlock} from "../../model/markdown/MarkdownText"
import {AtomsViewer} from "../atoms/AtomsViewer"
import {codeBlockHintService} from "../../service/markdown/codeBlockHintService"
import {plainTextService} from "../../service/markdown/plainTextService"
import {PlantUmlCodeViewer} from "./PlantUmlCodeViewer"
import './MarkdownCode.less'

interface MarkdownCodeProps {
    block: MarkdownBlock
    onToggleCheckBox: (atom: MarkdownAtom) => void
}

export const MarkdownCode: FC<MarkdownCodeProps> = ({
                                                        block,
                                                        onToggleCheckBox
                                                    }) => {
    const source = plainTextService.getCodeBlockAsPlainText(block.atoms)
    const isPlantUml = codeBlockHintService.isPlantUml(block.hint)

    if (isPlantUml && source.length > 0) {
        return (
            <PlantUmlCodeViewer block={block} source={source} onToggleCheckBox={onToggleCheckBox}/>
        )
    }

    return (
        <div className="block code">
            {block.hint.length > 0 && <div className="hint">{block.hint}</div>}
            <AtomsViewer atoms={block.atoms} onToggleCheckBox={onToggleCheckBox}/>
        </div>
    )
}
